import React from 'react';

import { Client } from '@netfront/gelada-react-shared';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import QueryRequest from '../QueryRequest';

export const GET_PROJECT_MEMBERSHIP_LIST = gql`
  query getProjectMembership($projectId: String!) {
    membership {
      getTeamMembers(projectId: $projectId) {
        id
        permission: permision
        userId
        user {
          id
          credential {
            email
          }
          firstname
          lastname
          status
        }
      }
    }
  }
`;

const getProjectMemberShipListRequest = ({
  projectId,
  onError,
  onSuccessResult,
}) => (
  <Query
    client={Client()}
    query={GET_PROJECT_MEMBERSHIP_LIST}
    variables={{ projectId }}
  >
    {({ loading, error, data }) => (
      <QueryRequest
        data={
          data &&
          Object.entries(data).length !== 0 &&
          data.membership.getTeamMembers
        }
        error={error}
        isLoading={loading}
        onError={onError}
        onSuccessResult={onSuccessResult}
      />
    )}
  </Query>
);

getProjectMemberShipListRequest.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
};

export default getProjectMemberShipListRequest;
